//node_modules
import React, { FunctionComponent, PropsWithChildren } from "react";
import { GoogleAnalytics } from "nextjs-google-analytics";
import { If, Then } from "react-if";

//src constants
import HeaderComponent from "src/components/header-component";
import FooterComponent from "@adjust/website/src/components/FooterComponent";

const enabled = process.env.NODE_ENV === "production";
const gaMeasurementId = process.env["NEXT_PUBLIC_GA_MEASUREMENT_ID"];

const SiteLayout: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <React.Fragment>
      <If condition={enabled}>
        <Then>
          <GoogleAnalytics gaMeasurementId={gaMeasurementId} trackPageViews />
        </Then>
      </If>
      <HeaderComponent />
      {children}
      <div className="my-auto" />
      <FooterComponent />
    </React.Fragment>
  );
};

export default SiteLayout;
